import CustomColorPicker, { CustomColorPickerProps } from "./CustomColorPicker";

export { CustomColorPicker };
export type { CustomColorPickerProps };
export default CustomColorPicker;
